module.exports = "/packs/images/home/device-fbf999817b3836f24d870c77e2b9c288.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/home/device.png
// module id = 1821
// module chunks = 0